import { render, staticRenderFns } from "./SmileyRating.vue?vue&type=template&id=b07c24da&scoped=true&"
import script from "./SmileyRating.vue?vue&type=script&lang=js&"
export * from "./SmileyRating.vue?vue&type=script&lang=js&"
import style0 from "./SmileyRating.vue?vue&type=style&index=0&id=b07c24da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07c24da",
  null
  
)

export default component.exports